import { unreachable } from '../utils/unreachable';

export enum Effort {
  Easy = 1,
  Medium = 2,
  Huge = 3,
}

export function getEffortLabel(status: Effort, t: (key: string) => string): string {
  switch (status) {
    case Effort.Easy:
      return t('Easy');
    case Effort.Medium:
      return t('Medium');
    case Effort.Huge:
      return t('Huge');
    default:
      return unreachable(status);
  }
}
